module.exports = __webpack_public_path__ + "img/suning.0a7d9ef0.png";